'use strict';
import DataQueryList from './mx-data-query-list.js';

angular.module('mx.SolutionBuilderAgent').component('mxContentWidgetViewBoard', {
	transclude: true,
	bindings: {
		parameters: '<',
		// tilesConfig: '<',
		outputPreprocessors: '<',
	},
	controller: MxContentWidgetViewBoardCtrl,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-content-widget-view/list/mx-content-widget-view-board.html',
});

MxContentWidgetViewBoardCtrl.$inject = [
	'$q',
	'$injector',
	'$scope',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.SolutionBuilderAgent.PagingPreprocessor',
	'mx.SolutionBuilderAgent.SearchPreprocessor',
	'mx.SolutionBuilderAgent.SortingPreprocessor',
	'mx.SolutionBuilderAgent.QuickFilterPreprocessor',
	'mx.SolutionBuilderAgent.ColumnDefinitionPreprocessor',
	'mx.SolutionBuilderAgent.GroupingPreprocessor',
];
MxContentWidgetViewBoardCtrl.prototype = Object.create(DataQueryList.prototype);

function MxContentWidgetViewBoardCtrl(
	$q,
	$injector,
	$scope,
	personalizationService,
	entityService,
	PagingPreprocessor,
	SearchPreprocessor,
	SortingPreprocessor,
	QuickFilterPreprocessor,
	ColumnDefinitionPreprocessor,
	GroupingPreprocessor
) {
	var vm = this;
	var horizontalGroupingField,
		horizontalGroupingFieldExpression,
		horizontalGroupingValues = [];
	var useCustomTile = false;

	vm.$onInit = function () {
		vm.type = mx.SolutionBuilderAgent.ListingType.board;
		// vm.pageSizes = [20];
		vm.preInitialize($injector, $scope);
		vm.initPreprocessors([PagingPreprocessor, SearchPreprocessor, SortingPreprocessor, QuickFilterPreprocessor, ColumnDefinitionPreprocessor, GroupingPreprocessor]);
		if (typeof vm.outputPreprocessors === 'object') {
			angular.extend(vm.outputPreprocessors, vm.preprocessorsByName);
		}

		vm.itemTitlePropertyName = 'Sys-DisplayName';

		vm.parameters.board.groupingIsAvailable = vm.dataQueryExecutor.supportsGrouping();
		if (!vm.parameters.board.groupingIsAvailable) {
			return;
		}

		vm.load().then(initBoard);
	};

	function initBoard() {
		initAvailableFields(); // init configuration for "fields which are available for grouping in board, can be used as horizontal (or vertical in future) grouping and changed in settings panel"
		initHorizontalGroupingFieldAndValues(); // init configuration for for field which is used now for horizontal grouping, all possible values of this field automatically loaded and shown in settings panel
		initCustomTileAndVisibleFieldsInTile(); // init configuration for fields which are set from settings panel and shown in dynamic tile

		return loadPersonalization().then(function () {
			vm.tileTemplate = createTemplate();
		});
	}

	vm.onItemChanged = onItemChanged;

	vm.$postLink = function () {};

	vm.$onDestroy = function () {
		DataQueryList.prototype.$onDestroy.call(this);
		delete vm.parameters.board.horizontalGroupingField;
		delete vm.parameters.board.availableFields;
		delete vm.parameters.board.visibleFieldsInTile;
		delete vm.parameters.board.horizontalGroupingValues;
		delete vm.parameters.board.useCustomTile;
	};

	return vm;

	function loadPersonalization() {
		return $q
			.all([
				personalizationService.getBoardHorizontalGroupingField(vm.parameters.id),
				personalizationService.getBoardVisibleFields(vm.parameters.id),
				personalizationService.getBoardUseCustomTile(vm.parameters.id),
				// personalizationService.getBoardHorizontalGroupingField(vm.parameters.id)
			])
			.then(function (personalization) {
				vm.parameters.board.horizontalGroupingField = personalization[0] || vm.parameters.board.defaultHorizontalGroupingField;

				angular.extend(vm.visibleFields, personalization[1]);
				vm.parameters.board.visibleFieldsInTile.forEach(function (field) {
					field._visible = vm.visibleFields[field.value];
				});

				vm.parameters.board.useCustomTile = personalization[2];
			});
	}

	function initAvailableFields() {
		var availableFields = vm.columnDefinitionPreprocessor.allColumns
			.filter(function (column) {
				return column.GroupingIsAvailable && column.IsDisplay && column.ReferenceTo && column.AttributeValueType === mx.shell.ObjectPropertyType.Integer.name; //temporary only for enums
			})
			.map(function (column) {
				return {
					title: column.Title || column.Name,
					value: column.Name,
				};
			});

		Object.defineProperty(vm.parameters.board, 'availableFields', {
			configurable: true,
			get: function () {
				return availableFields;
			},
		});
	}

	function initCustomTileAndVisibleFieldsInTile() {
		Object.defineProperty(vm.parameters.board, 'useCustomTile', {
			configurable: true,
			get: function () {
				return useCustomTile;
			},
			set: function (newValue) {
				if (useCustomTile !== newValue) {
					useCustomTile = newValue;
					personalizationService.saveBoardUseCustomTile(useCustomTile, vm.parameters.id);
					updateTemplate();
				}
			},
		});

		vm.visibleFields = {};
		var visibleFieldsInTile = vm.columnDefinitionPreprocessor.allColumns
			.filter(function (column) {
				return column.IsDisplay === true;
			})
			.map(function (column) {
				var col = {
					title: column.Title || column.Name,
					value: column.Name,
					_visible: false,
				};
				Object.defineProperty(col, 'visible', {
					get: function () {
						return this._visible;
					},
					set: function (newValue) {
						if (newValue !== this._visible) {
							this._visible = newValue;
							vm.visibleFields[this.value] = newValue;
							personalizationService.saveBoardVisibleFields(vm.visibleFields, vm.parameters.id);
						}
					},
				});
				vm.visibleFields[col.value] = col.visible;
				return col;
			});

		Object.defineProperty(vm.parameters.board, 'visibleFieldsInTile', {
			configurable: true,
			get: function () {
				return visibleFieldsInTile;
			},
		});
	}

	function initHorizontalGroupingFieldAndValues() {
		Object.defineProperty(vm.parameters.board, 'horizontalGroupingField', {
			configurable: true,
			get: function () {
				return horizontalGroupingField;
			},
			set: function (newValue) {
				if (horizontalGroupingField !== newValue) {
					setHorizontalGroupingField(newValue);
				}
			},
		});

		Object.defineProperty(vm.parameters.board, 'horizontalGroupingValues', {
			configurable: true,
			get: function () {
				return horizontalGroupingValues;
			},
			set: function (newValue) {
				horizontalGroupingValues = Array.isArray(newValue) ? newValue : [];
				var currentHorizontalGroupingField = horizontalGroupingField;

				personalizationService.getBoardVisibleColumns(vm.parameters.id, horizontalGroupingField).then(function (personalizedColumns) {
					if (currentHorizontalGroupingField !== horizontalGroupingField) {
						return; // if field was changed during personalization loading than don't enable this personalization and wait fot next
					}
					horizontalGroupingValues.forEach(function (item) {
						item._visible = !Array.isArray(personalizedColumns) || personalizedColumns.indexOf(item.value) >= 0;
						Object.defineProperty(item, 'visible', {
							get: function () {
								return this._visible;
							},
							set: function (newValue) {
								this._visible = newValue;
								updateVisibleColumns();
							},
						});
					});
					updateVisibleColumns();
				});
			},
		});
	}

	function setHorizontalGroupingField(newValue) {
		if (horizontalGroupingField === newValue) {
			return;
		}
		vm.columnDefinitionPreprocessor.allColumns.some(function (column) {
			if (/*column.boardGroupingIsAvailable &&*/ newValue === column.Name) {
				horizontalGroupingField = newValue;
				horizontalGroupingFieldExpression = column.Expression;
				personalizationService.saveBoardHorizontalGroupingField(horizontalGroupingField, vm.parameters.id);

				// vm.parameters.board.horizontalGroupingValues = [];
				getAllColumnValues(column).then(function (columnValues) {
					vm.parameters.board.horizontalGroupingValues = columnValues;
				});
				return true;
			}
		});
	}

	function onItemChanged(item, newColumnValue /*, itemBefore, itemAfter*/) {
		entityService.updateEntity(item._type, item._id, vm.parameters.dataQuery.SchemaClassName, [
			{
				Expression: horizontalGroupingFieldExpression,
				Value: newColumnValue,
			},
		]);
	}

	function createTemplate() {
		if (typeof vm.parameters.board.template === 'string' && vm.parameters.board.template.length && !vm.parameters.board.useCustomTile) {
			var re = new RegExp('vm.dataModel', 'g');
			return vm.parameters.board.template.replace(re, '__vm.dataModel');
		}

		var template = '<mx-object-link value="::item" mx-at-id="default-item-title"></mx-object-link>';

		if (Array.isArray(vm.parameters.board.visibleFieldsInTile) && vm.parameters.board.visibleFieldsInTile.length && vm.parameters.board.useCustomTile) {
			template += '<h3 class="layout-column" mx-at-id="custom-tile">';

			vm.parameters.board.visibleFieldsInTile.forEach(function (field) {
				var fieldTemplate =
					'<mx-literal data-type="string" label-position="top" ' +
					' data-label="' +
					field.title +
					'" ' +
					' data-value="::item[\'' +
					field.value +
					'\']" ' +
					' ng-if="__vm.visibleFields[\'' +
					field.value +
					'\']" ' +
					' ></mx-literal>';

				template += fieldTemplate;
			});

			template += '</h3>';
		}

		return template;
	}

	function updateTemplate() {
		vm.tileTemplate = createTemplate();
	}

	function updateVisibleColumns() {
		vm.parameters.board.visibleColumns = horizontalGroupingValues.filter(function (field) {
			return field.visible;
		});
		var personalizedColumns = vm.parameters.board.visibleColumns.map(function (column) {
			return column.value;
		});
		personalizationService.saveBoardVisibleColumns(personalizedColumns, horizontalGroupingField, vm.parameters.id);
	}

	function getAllColumnValues(column) {
		//TODO: should return DISTINCT list

		// if (boardGroupingIsAvailable)
		if (column.ReferenceTo && column.AttributeValueType === mx.shell.ObjectPropertyType.Integer.name) {
			//if enum
			return entityService.getEnumerationValues(column.ReferenceTo, column.ReferenceFilter).then(function (enumeration) {
				return enumeration.map(function (item) {
					return {
						title: item.DisplayString || item.Name,
						value: item.Value,
					};
				});
			});
		}

		/*if (column.ReferenceTo && column.AttributeValueType === mx.shell.ObjectPropertyType.Guid.name) { //if relation
			dataQueryService.getRelationItems(request)
			request = {
				dataQueryName: vm.columnDefinition,
				entityClassName: vm.entityClassName,
				relationName: vm.relationName,
				whereExpression: vm.filter
			};
		}


		if (column.AttributeValueType === mx.shell.ObjectPropertyType.Boolean.name) {

		}*/

		return $q.when([]);
	}
}
